import _typeof from "@babel/runtime/helpers/typeof";
import React from 'react';
import { Box } from '@mui/material';
import { LoaderView } from '@components';
import { colors } from '@themes';
import { jsx as _jsx } from "react/jsx-runtime";

var WithSuspense = function WithSuspense(Module) {
  return /*#__PURE__*/_jsx(React.Suspense, {
    fallback: /*#__PURE__*/_jsx(Box, {
      sx: {
        height: '100vh',
        backgroundColor: colors.mirage
      },
      children: /*#__PURE__*/_jsx(LoaderView, {
        isShowLoader: true
      })
    }),
    children: _typeof(Module) === 'object' ? Module : /*#__PURE__*/_jsx(Module, {})
  });
};

export { WithSuspense };